export default __webpack_public_path__ + "static/media/background.a2fb5a50.png";